import React, { ReactNode, ReactElement, useMemo } from 'react';
import { Button } from '@fluentui/react-components';

import { getButtonSize } from '../utils/size-utils';
import { useEmptyStateSizeContext } from '../contexts/size';

interface EmptyStateButtonProps {
  className?: string;
  children: ReactNode;
  icon?: ReactElement;
  appearance?: 'primary' | 'secondary';
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

export const EmptyStateButton = ({
  className,
  children,
  appearance = 'primary',
  icon,
  onClick,
}: EmptyStateButtonProps) => {
  const { size } = useEmptyStateSizeContext();
  const buttonSize = useMemo(() => getButtonSize(size), [size]);

  return (
    <Button
      className={className}
      appearance={appearance}
      icon={icon}
      onClick={onClick}
      size={buttonSize}
    >
      {children}
    </Button>
  );
};
